import { combineReducers } from "@reduxjs/toolkit";
import coreReducer from "../shared/core/redux";
import signUpReducer from "../shared/signup/redux";
import checkinReducer from "./checkin/redux";
import vendorsReducer from "./vendors/redux";

const rootReducer = combineReducers({
  common: combineReducers({
    auth: coreReducer.reducer,
    signup: signUpReducer.reducer,
  }),
  checkin: checkinReducer.reducer,
  vendors: vendorsReducer,
});

export default rootReducer;
